<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh">Contents</p>
<p class="toc"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="toc"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc"><a href="#/xhtml/ack#ack">Acknowledgments</a></p>
<p class="toc-bot"><a href="#/xhtml/about#ata">About The Carpet Makers …</a></p>
<p class="toc"><a href="#/xhtml/chapter1#ch1">I. The Carpet Makers</a></p>
<p class="toc"><a href="#/xhtml/chapter2#ch2">II. The Hair-Carpet Trader</a></p>
<p class="toc"><a href="#/xhtml/chapter3#ch3">III. The Hair-Carpet Preacher</a></p>
<p class="toc"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">IV. The Lost Hair Carpet</span></p>
<p class="toc"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">V. The Peddler Woman</span></p>
<p class="toc"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">VI. The Man from Someplace Else</span></p>
<p class="toc"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">VII. The Tax Collector</span></p>
<p class="toc"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">VIII. The Hair-Carpet Robbers</span></p>
<p class="toc"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">IX. Flute Fingers</span></p>
<p class="toc"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">X. The Emperor’s Archivist</span></p>
<p class="toc"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">XI. Jubad</span></p>
<p class="toc"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">XII. The Emperor and the Rebel</span></p>
<p class="toc"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">XIII. I’ll See You Again!</span></p>
<p class="toc"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">XIV. The Palace of Tears</span></p>
<p class="toc"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">XV. When We See the Stars Again</span></p>
<p class="toc"><span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample">XVI. The Return</span></p>
<p class="toc"><span href="#/xhtml/chapter17#ch17" title="Link target outside of Sample">XVII. Vengeance Is Eternal</span></p>
<p class="toc-bot"><span href="#/xhtml/epilogue#ep" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc"><span href="#/xhtml/praise#pr" title="Link target outside of Sample">Praise for Andreas Eschbach and <span class="epub-i">The Carpet Makers</span></span></p>
<p class="toc"><span href="#/xhtml/copyright#crp" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?2f5d2195